export class FormPilaRq {
    'channel': string;
    'bankId': string;
    'clientDt': string;
    'ipAddr': string;
    'rqUID': string;
    'billNumber': string;

}